import Nullstack from 'nullstack';
export default function IconDragDrop({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-drag-drop",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M19 11v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2"
  }), "   ", Nullstack.element("path", {
    d: "M13 13l9 3l-4 2l-2 4l-3 -9"
  }), "   ", Nullstack.element("line", {
    x1: "3",
    y1: "3",
    x2: "3",
    y2: "3.01"
  }), "   ", Nullstack.element("line", {
    x1: "7",
    y1: "3",
    x2: "7",
    y2: "3.01"
  }), "   ", Nullstack.element("line", {
    x1: "11",
    y1: "3",
    x2: "11",
    y2: "3.01"
  }), "   ", Nullstack.element("line", {
    x1: "15",
    y1: "3",
    x2: "15",
    y2: "3.01"
  }), "   ", Nullstack.element("line", {
    x1: "3",
    y1: "7",
    x2: "3",
    y2: "7.01"
  }), "   ", Nullstack.element("line", {
    x1: "3",
    y1: "11",
    x2: "3",
    y2: "11.01"
  }), "   ", Nullstack.element("line", {
    x1: "3",
    y1: "15",
    x2: "3",
    y2: "15.01"
  }), " ");
}